import styled from "styled-components";
import Input from "../../../Common/Components/Input";
import SmallButton from "../../../Content/Shared/SmallButton";
import PasswordValid from "../../../Common/Components/PasswordValid";
import xiqLogo from "../../../../assets/img/Workbench_Logo.svg";
import BG from "../../../../assets/img/Signup_BG.png";
import Logo from "../../../../assets/img/Logo.svg";
import BlueBG from "../../../../assets/img/BlueBG.png";
import { Row, Col } from "antd";
import SignupForm from "./SignupForm";

const LoginWrapper = styled.div`
  .wraper-full {
    padding: 0 60px;
    background: rgb(249, 248, 246);
    &.wraper-light {
      background-color: rgb(255, 255, 255);
      background-image: url(${BG});
      background-repeat: no-repeat;
      background-position: 0px 0px;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .wraper {
      max-width: 1160px;
      margin: 0 auto;
      .logo {
        max-width: 250px;
        margin-bottom: 40px;
        margin-top: 50px;
        margin-left: -50px;
      }
      h1 {
        font-size: 32px;
        color: rgb(0, 23, 96);
        font-weight: 600;
        font-family: "Roboto Slab", serif;
        letter-spacing: -0.71px;
        line-height: 40px;
        width: 400px;
        margin-bottom: 0px;
        margin-left: 22px;
      }
      h2 {
        font-size: 38px;
        color: rgb(66, 75, 80);
        font-weight: 600;
        font-family: "robotomedium";
        letter-spacing: -0.75px;
        margin-bottom: 12px;
      }
      h3 {
        font-size: 38px;
        font-family: "Roboto Slab", serif;
        color: rgb(66, 75, 80);
        font-weight: 600;
        letter-spacing: -0.56px;
        margin-bottom: 8px;
      }
      p {
        font-size: rgb(94, 112, 121);
        font-size: 16px;
        font-family: "robotoregular";
        margin-bottom: 0px;
        letter-spacing: -0.31px;
      }
      .last-row {
        padding: 50px 0 100px 0;
      }
      .fancy-box {
        border-radius: 22px;
        box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
        background: rgb(255, 255, 255);
        padding: 40px 50px 25px 50px;
        input {
          font-size: 16px;
          padding: 7px 12px;
        }
        .extended-box {
          background-color: rgb(248, 248, 248);
          margin-left: -50px;
          margin-right: -50px;
          margin-bottom: -25px;
          padding-left: 50px;
          padding-right: 50px;
          padding-top: 1px;
          position: relative;
          border-radius: 0 0 24px 24px;
          .password + span {
            top: 15px;
          }
        }
      }
      .blue-banner {
        background-color: #333f5e;
        background-image: url(${BlueBG});
        background-size: calc(100% + 24px) calc(100% + 25px);
        background-position: -12px -12px;
        background-repeat: no-repeat;
        box-sizing: border-box;
        border-radius: 8px;
        padding: 20px;
        margin-top: 50px;
        margin-bottom: 60px;
        .small-logo {
          border-radius: 10px;
          background-color: #ffffff;
          padding: 20px 8px;
          text-align: center;
          img {
            max-width: 100%;
          }
        }
        h4 {
          color: #ffffff;
          font-size: 16px;
          font-family: "Roboto Slab", serif;
          margin: 7px 0;
          font-weight: 400;
          margin-left: 10px;
        }
        p {
          color: #ffffff;
          font-size: 16px;
          font-family: "robotoregular";
          margin-bottom: 0px;
          line-height: 14px;
          margin-left: 10px;
        }
        button {
          background: #ffffff;
          color: #11418b;
          font-size: 12px;
          margin-top: 7px;
          padding: 8px 12px;
          &:active,
          &:focus {
            box-shadow: 0 0 0 0.2rem rgb(255 255 255 / 50%);
          }
        }
        .learn-more {
          display: block;
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          font-family: "helveticaneuebold";
          margin-top: 8px;
        }
      }
    }
  }
`;

const SignUpPage = (props) => {
  return (
    <LoginWrapper>
      <div className="wraper-full wraper-light">
        <div className="wraper">
          <Row>
            <Col span={24}>
              <a>
                <img src={xiqLogo} alt="xIQ" className="logo" />
              </a>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col span={13} className="pr-4 ">
              <SignupForm />
              <div className="fancy-box d-none">
                <h3 className="pt-3 mt-1">Create your account</h3>
                <p>
                  I would like xiQ to reach out to me to discuss how Workbench can benefit my organization’s sales
                  and marketing efforts
                </p>
                <Row gutter={30}>
                  <Col span={12}>
                    <Input label="First name" placeholder="Enter First Name…" type="text" />
                  </Col>
                  <Col span={12}>
                    <Input label="Last name" placeholder="Enter Last Name…" type="text" />
                  </Col>
                </Row>
                <Input label="Company" placeholder="Enter your company name…" type="text" />
                <Input label="Phone number" placeholder="+1 123 456 7890" type="tel" />
                <Input label="Code (optional)" placeholder="Enter code…" type="text" />
                <br />
                <div className="extended-box">
                  <PasswordValid uppercase="" number="true" special="false" long="true" />
                  <Input
                    label="Create your password"
                    placeholder="Enter a password…"
                    type="password"
                    className="password"
                  />
                  <Input
                    label="Re-enter your password"
                    placeholder="Re-enter a password…"
                    type="password"
                    className="password"
                  />
                  <div className="mt-4">I'm not a robot</div>
                  <br />
                  <Row gutter={30}>
                    <Col span={24} className="text-center pb-4">
                      <SmallButton title="Create Account Now" />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col span={11} style={{ paddingLeft: "30px", paddingTop: "60px" }}>
              <h2>Powerful AI Content Engine</h2>
              <p>
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
                Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
              </p>
              <br />
              <p className="mb-4 pb-4">
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo.
              </p>
              <br />
              <h2 className="mt-4 pt-4">Hone your content, magically</h2>
              <p>
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
                Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
              </p>
              <br />
              <p>
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo.
              </p>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="blue-banner">
                <Row gutter={16}>
                  <Col span={2} className="small-logo">
                    <img src={Logo} alt="xIQ" />
                  </Col>
                  <Col span={16}>
                    <h4>Already an xiQ Sales Intelligence App user?</h4>
                    <p>
                      xiQ’s unique, automated and intelligent behavioural and personality based profiling tools
                      help you know your audience, and tailor the content you send them — increasing engagement
                      across the board
                    </p>
                  </Col>
                  <Col span={6} className="text-center">
                    <SmallButton title="Sales App + Workbench" />
                    <a href="#" className="learn-more">
                      Learn more
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row gutter={40} style={{ marginBottom: "60px" }} className="px-3">
            <Col span={8}>
              <h2>Switch anytime</h2>
              <p>
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo. Vivamus sagittis lacus vel augue.
              </p>
            </Col>
            <Col span={8}>
              <h2>Grows with you</h2>
              <p>
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo. Vivamus sagittis lacus vel augue.
              </p>
            </Col>
            <Col span={8}>
              <h2>Today’s conversation</h2>
              <p>
                Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Nullam quis risus eget urna
                mollis ornare vel eu leo. Vivamus sagittis lacus vel augue.
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <div className="wraper-full">
        <div className="wraper">
          <Row className="last-row" gutter={16}>
            <Col span={13} className="align-self-center">
              <h1>Get the most powerful platform to help you enter today’s conversations, today</h1>
            </Col>
            <Col span={11}>
              <div className="fancy-box">
                <h3>Tell me more…</h3>
                <p>
                  I would like xiQ to reach out to me to discuss how Workbench can benefit my organization’s sales
                  and marketing efforts
                </p>
                <Input label="Name" placeholder="Enter your Name…" type="text" />
                <Input label="Email" placeholder="Enter your email address…" type="email" />
                <br />
                <SmallButton title="Send me more info" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </LoginWrapper>
  );
};

export default SignUpPage;
